import { getUnixTime } from 'date-fns';
import { localTimezone } from "@/shared/datetime.js";
const axios = window.axios;

export default {
    install: (app, options) => {
        const setUpCustomerIO = (user) => {
            if (!user || !user.email) {
                return
            }
            const names = user.name ? user.name.split(" ") : ['', '']
            const timezone = localTimezone();
            const payload = {
                id: user.id,
                email: user.email,
                created_at: user.sign_up_date_unix_timestamp,
                first_name: names[0],
                last_name: names[1] ?? null,
                plan_name: user.base_plan_name,
                last_login_date: user.logged_in_at ? getUnixTime(new Date(user.logged_in_at)) : null,
                last_active_at: user.last_active_at ? getUnixTime(new Date(user.last_active_at)) : null,
                is_verified: user.is_verified,
                is_paid: user.is_paid,
                team_plan: user.team_base_plan_name,
                timezone,
            }
            if (options._cio) {
                options._cio.identify(payload)
                if (!user.is_customer_io_identified || !user.timezone) {
                    axios.post("/api/v2/customer-io-identified", { timezone })
                }
            }
        }
        const trackEvent = (event, payload) => {
            if (options._cio) {

                options._cio.track(event, payload)
            }
        }
        const reset = () => {
            if (options._cio && options._cio.reset) {
                options._cio.reset()
            }
        }
        if (options.user) {
            setUpCustomerIO(options.user)
        }
        app.config.globalProperties.$_cio = {
            setUpCustomerIO: setUpCustomerIO,
            trackEvent: trackEvent,
            reset: reset
        }
    }
}
